import { StarIcon } from "@heroicons/react/20/solid";
import axios from "axios";
import BasicArticle from "components/Article/Basic";
import SpinnerMedium from "components/Spinner/Medium";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Wrapper as GoogleMapWrapper } from "@googlemaps/react-wrapper";
import GoogleMapComponent from "components/Map/Google";
import { GOOGLE_MAP_API_KEY } from "../../Clinic/ClinicDetail/ClinicInfo";
import { formatKoreanAddress } from "components/Form/KoreanAddressInput";
import TopNav from "common/components/TobNav";
import { staffClient } from "common/apis/staff";
import { UrlUtils } from "components/Utils/url";
import BottomBookmarkBar from "common/components/BottomBookmarkBar";
import Tabs from "components/Tabs";
import Tab from "components/Tabs/Tab";
import { ReviewCard } from "common/pages/Clinic/ClinicDetail/ClinicReviewList";
import numeral from "numeral";
import ReviewList from "common/pages/Review/ReviewList";
import { BuildingOfficeIcon } from "@heroicons/react/24/outline";

const EventInfo = ({ eventInfo }) => {
    const navigate = useNavigate();

    return (
        <div>
            <div className="p-5">
                <div className="font-semibold">
                    이벤트 설명
                </div>
                <div className="mt-3">
                    {_.isEmpty(eventInfo.content) ? (
                        <div className="text-sm text-gray-400">
                            작성된 이벤트 설명이 없습니다
                        </div>
                    ) : (
                        <BasicArticle>
                            <div className="text-sm leading-normal">
                                {eventInfo.content}
                            </div>
                        </BasicArticle>
                    )}
                </div>
            </div>
            <div className="border-t border-gray-200"></div>
            <div>
                <div className="p-5">
                    <div className="font-semibold">
                        상세정보
                    </div>
                </div>
                {_.isEmpty(eventInfo?.detailImages) ? (
                    <div>
                        <div className="text-sm text-gray-400 px-5 pb-5">
                            작성된 상세정보가 없습니다
                        </div>
                    </div>
                ) : (eventInfo.detailImages.map((file, idx) => {
                    return (
                        <div>
                            <img src={UrlUtils.convertCdnUrl(file?.url)} alt={`detail_img_${idx}`} />
                        </div>
                    )
                }))}
            </div>
            <div className="border-t border-gray-200"></div>
            <div className="p-5 cursor-pointer" onClick={() => {
                navigate(`/contents/clinic/${eventInfo.clinic.id}`);
            }}>
                <div className="font-semibold">
                    의원 정보
                </div>
                <div className="flex mt-3 items-center">
                    {!_.isEmpty(eventInfo.clinic.profileImage) ?
                        <img
                            src={UrlUtils.convertCdnUrl(eventInfo?.clinic?.profileImage?.url)}
                            alt="profileImage"
                            className="h-24 w-24 p-2 object-center"
                        /> :
                        <div className="flex justify-center text-pink-300 size-24">
                            <div className="flex justify-center ring ring-inset ring-pink-300 ring-[6px] rounded-full size-20 self-center">
                                <BuildingOfficeIcon className="size-14 self-center" />
                            </div>
                        </div>
                    }
                    <div className="p-2">
                        <div className="text-lg font-bold self-center">
                            {eventInfo.clinic.name}
                        </div>
                        <div className="text-sm text-gray-500 self-center">
                            {formatKoreanAddress(eventInfo?.clinic?.address)}
                        </div>
                    </div>
                </div>
                <GoogleMapWrapper apiKey={GOOGLE_MAP_API_KEY}>
                    <GoogleMapComponent
                        address={formatKoreanAddress(eventInfo.clinic.address)}
                        title={eventInfo.clinic.name}
                        width="100%"
                        height="200px"
                    />
                </GoogleMapWrapper>
            </div>
        </div>

    )
}

const EventDetail = ({ }) => {
    const { eventId } = useParams();
    const [eventInfo, setEventInfo] = useState(null);

    useEffect(() => {
        if (eventId === "pv") {
            console.log("[EventDetail] eventId is empty it's maybe preview page");
            console.log("[EventDetail] try get from localstorage");
            const tempEventInfoStr = localStorage.getItem("tempEventInfo");
            if (_.isNil(tempEventInfoStr)) {
                console.log("[EventDetail] tempEventInfoStr is empty");
                return;
            }
            const tempEventInfo = JSON.parse(tempEventInfoStr);
            console.log("[EventDetail] tempEventInfo", tempEventInfo);
            setEventInfo(tempEventInfo);
        }
        fetchEventInfo();
    }, [eventId]);

    const fetchEventInfo = async () => {
        if (_.isNil(eventId)) {
            return;
        }
        try {
            const ret = await axios.get(`https://rest.miview.shop/public/events/${eventId}`);
            // const ret = await staffClient.get(`/event/${eventId}`);
            console.log("[fetchEventrInfo] ret", ret.data);
            setEventInfo(ret.data);
        } catch (e) {
            console.error("[fetchEventrInfo] error", e);
        }
    }

    console.log("[EventDetail] eventInfo", eventInfo);

    if (_.isNil(eventInfo)) {
        return <SpinnerMedium />;
    }

    return (
        <div className="pb-16">
            <TopNav
                pages={[
                    {
                        name: "탐색",
                        path: "/contents"
                    },
                    {
                        name: "이벤트",
                        path: "/contents?tabId=events"
                    },
                    {
                        name: eventInfo.title
                    }
                ]}
                disablePlus={true}
            />
            <div className="flex flex-col">
                {!_.isEmpty(eventInfo?.cardImage?.url) && (
                    <div>
                        <img src={UrlUtils.convertCdnUrl(eventInfo.cardImage?.url)} alt={eventInfo.title} />
                    </div>
                )}
                <div className="border-t border-gray-200"></div>
                <div>
                    <div className="p-5">
                        <span className="font-bold text-lg">
                            {eventInfo.title}
                        </span>
                        <div className="flex items-center mt-2">
                            <StarIcon className="w-4 h-4 text-yellow-400" />
                            <span className="text-gray-500 text-xs">
                                {numeral(eventInfo.averageRating).format("0.0")}
                            </span>
                            <span className="ms-[2px] text-gray-600 text-xs">
                                {`(${numeral(eventInfo.reviewCount).format("0,0")}개의 후기)`}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="border-t border-gray-200"></div>
                <Tabs isEvenFullWidth={true}>
                    <Tab title='이벤트 정보' path="info">
                        <EventInfo eventInfo={eventInfo} />
                    </Tab>
                    <Tab title='이벤트 후기' path="review">
                        <ReviewList filterParams={{ eventId: eventId }} />
                    </Tab>
                </Tabs>
                <BottomBookmarkBar
                    clinicId={Number(eventInfo.clinic.id)}
                    bookmarkableType="EVENT"
                    bookmarkableId={Number(eventId)}
                />
            </div>
        </div>

    )
}

export default EventDetail;
